<template>
  <div>
    <radar-help-modal />
    <basic-portlet title="Analytics">
      <template #portlet_actions>
        <a href="https://radar.sharp-stream.com/sharpstream/podcasts" target="_blank" class="btn btn-ss mr-2">
          <i class="flaticon2-analytics-2" />
          <span> More Analytics</span>
        </a>
        <button id="radar_help_btn" type="button"
                class="btn btn-ss btn-icon"
                @click="fireModal(`radar-help`);">
          <i class="flaticon-questions-circular-button" />
        </button>
      </template>
      <div class="holder">
        <div v-if="customer_too_new">
          <div class="row">
            <div class="col-12 text-center mb-4">
              <h4>
                Waiting for your highlights?
              </h4>
              <p class="h5 font-weight-normal">
                Check back on the 1st of {{ next_month }} for your insights
              </p>
            </div>
          </div>
        </div>
        <div class="position-relative">
          <div v-if="customer_too_new" class="mask" />
          <div class="row equal-height-row">
            <div v-for="highlight in highlights" :key="highlight.key" class="col-6 col-md-3 mb-4">
              <div class="card card-stats h-100">
                <div v-if="!highlight.loading && !highlight.error" class="card-body d-flex flex-column">
                  <div class="row">
                    <div class="col">
                      <h5 class="card-title text-uppercase text-muted mb-0">
                        {{ highlight.label }}
                      </h5>
                      <span v-if="highlight.value_name" v-sanitise="highlight.value_name" class="h4 mb-0" />
                    </div>
                    <div class="col-auto">
                      <span v-sanitise="highlight.value" class="h2 font-weight-bold mb-0" /><br>
                    </div>
                  </div>
                </div>
                <div v-if="highlight.loading && !highlight.error" class="card-body d-flex flex-column">
                  <loader loading-text="Gathering Analytics..." />
                </div>
                <div v-if="!highlight.loading && highlight.error" class="card-body d-flex flex-column">
                  Unable to gather analytics. Please contact SharpStream Support.
                </div>
              </div>
            </div>
          </div>
          <div class="row equal-height-row">
            <div class="col-12 col-md-6 mb-4">
              <div class="card card-stats h-100">
                <div v-if="!top_feed.loading && !top_feed.error" class="card-body d-flex flex-column">
                  <div class="row">
                    <div class="col-9">
                      <h5 class="card-title text-uppercase text-muted mb-0">
                        Top {{ getFeedLabel(true) }}
                      </h5>
                      <span class="h4 mb-0">{{ top_feed.name }}</span>
                      <table class="table w-100 mt-4 mb-0">
                        <tr>
                          <td class="pl-0">
                            Unique Users
                          </td>
                          <td>
                            {{ top_feed.data.users }}
                          </td>
                        </tr>
                        <tr>
                          <td class="pl-0">
                            Listen Time
                          </td>
                          <td>
                            {{ hoursToHumanTime(top_feed.data.total_listen_hours) }}
                          </td>
                        </tr>
                        <tr>
                          <td class="pl-0">
                            Listen Through Rate
                          </td>
                          <td>
                            {{ top_feed.data.ltr }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="col-3">
                      <img v-if="top_feed.img"
                           :src="top_feed.img"
                           class="border"
                           width="100%">
                    </div>
                  </div>
                </div>
                <div v-if="top_feed.loading && !top_feed.error" class="card-body d-flex flex-column">
                  <loader loading-text="Gathering Analytics..." />
                </div>
                <div v-if="!top_feed.loading && top_feed.error" class="card-body d-flex flex-column">
                  <h5 class="card-title text-uppercase text-muted mb-0">
                    Top {{ getFeedLabel(true) }}
                  </h5>
                  <p>{{ top_feed.error }}</p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-6 mb-4">
              <div class="card card-stats h-100">
                <div v-if="!top_item.loading && !top_item.error" class="card-body d-flex flex-column">
                  <div class="row">
                    <div class="col-9">
                      <h5 class="card-title text-uppercase text-muted mb-0">
                        Top {{ getItemLabel(true) }}
                      </h5>
                      <span class="h4 mb-0">{{ top_item.name }}</span>
                      <table class="table w-100 mt-4 mb-0">
                        <tr>
                          <td class="pl-0">
                            Unique Users
                          </td>
                          <td>
                            {{ top_item.data.users }}
                          </td>
                        </tr>
                        <tr>
                          <td class="pl-0">
                            Listen Time
                          </td>
                          <td>
                            {{ hoursToHumanTime(top_item.data.total_listen_hours) }}
                          </td>
                        </tr>
                        <tr>
                          <td class="pl-0">
                            Listen Through Rate
                          </td>
                          <td>
                            {{ top_item.data.ltr }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div class="col-3">
                      <img v-if="top_item.img"
                           :src="top_item.img"
                           class="border"
                           width="100%">
                    </div>
                  </div>
                </div>
                <div v-if="top_item.loading && !top_item.error" class="card-body d-flex flex-column">
                  <loader loading-text="Gathering Analytics..." />
                </div>
                <div v-if="!top_item.loading && top_item.error" class="card-body d-flex flex-column">
                  <h5 class="card-title text-uppercase text-muted mb-0">
                    Top {{ getItemLabel(true) }}
                  </h5>
                  <p>{{ top_item.error }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </basic-portlet>
  </div>
</template>

<script>
import Loader from "VuePartials/Loader";
import RadarHelpModal from "VueModals/RadarHelpModal";
import RadarMixin from "VueMixins/Analytics/RadarMixin";

export default {
  components: { RadarHelpModal, Loader },
  mixins: [RadarMixin],
  data() {
    return {
      top_feed: {
        loading: true,
        name: null,
        data: [],
        img: null,
        error: null,
      },
      top_item: {
        loading: true,
        name: null,
        data: [],
        img: null,
        error: null,
      },
      highlights: [
        {
          key: 'unique_users',
          label: 'Unique Users',
          value_name: null,
          value: 0,
          loading: true,
          error: null,
        },
        {
          key: 'top_device',
          label: 'Top Device',
          value_name: null,
          value: 0,
          loading: true,
          error: null,
        },
        {
          key: 'top_region',
          label: 'Top Region',
          value_name: null,
          value: 0,
          loading: true,
          error: null,
        },
        {
          key: 'total_listening_hours',
          label: 'Listen Time',
          value_name: null,
          value: 0,
          loading: true,
          error: null,
        },
      ],
    };
  },
  mounted() {
    if (!this.customer_too_new) {
      this.gatherData();
    } else {
      this.setPreviewData();
      this.setLoading(false);
    }
  },
  methods: {
    setPreviewData() {
      const unique_users_object = _.find(this.highlights,
        { key: 'unique_users' },
      );

      unique_users_object.value = 5500;

      const top_device_object = _.find(this.highlights,
        { key: 'top_device' },
      );

      top_device_object.value = 3000;
      top_device_object.value_name = 'Phone';

      const top_region_object = _.find(this.highlights,
        { key: 'top_region' },
      );

      top_region_object.value = 2500;
      top_region_object.value_name = 'England';

      const total_listening_hours_object = _.find(this.highlights,
        { key: 'total_listening_hours' },
      );

      total_listening_hours_object.value = '50d 10h 30m 10s';

      this.top_feed.name = "Drive-time with John Doe";
      this.top_feed.data.users = 500;
      this.top_feed.data.total_listen_hours = '200';
      this.top_feed.data.ltr = '70%';
      this.top_feed.img = '/build/media/misc/artwork_example_1.jpeg';

      this.top_item.name = "Exclusive interview with Special Guest...";
      this.top_item.data.users = 500;
      this.top_item.data.total_listen_hours = '122';
      this.top_item.data.ltr = '63%';
      this.top_item.img = '/build/media/misc/artwork_example_2.jpeg';
    },
    async gatherData() {
      try {
        // Get unique users, if there are no unique users then there is no point doing any other requests.
        await this.getUniqueUsers();
        const unique_users_object = _.find(this.highlights,
          { key: 'unique_users' },
        );
        if (!unique_users_object || !unique_users_object.value) {
          this.setLoading(false);
          return;
        }

        const apiCalls = [
          this.getTopDevice(),
          this.getTopRegion(),
          this.getTotalListeningHours(),
          this.getTopChannel(),
          this.getTopEpisode(),
        ];

        // Wait for all API calls to complete
        await Promise.all(apiCalls);
      } catch (error) {
        console.error(error.message);
      }
    },
    getUniqueUsers() {
      const target = _.find(this.highlights, { key: 'unique_users' });
      return axios.get('/api/v1/analytics/radar/unique-users').then((response) => {
        target.value = response.data.data.unique_users;
        target.loading = false;
      }).catch((error) => {
        target.loading = false;
        target.error = true;
        console.error('unable to retrieve unique users');
        console.error(error.message);
      });
    },
    getTopDevice() {
      const target = _.find(this.highlights, { key: 'top_device' });
      return axios.get('/api/v1/analytics/radar/top-device').then((response) => {
        target.value_name = response.data.data.device;
        const device_users = response.data.data.users ?? 0;
        target.value = `${device_users}`;
        target.loading = false;
      }).catch((error) => {
        target.loading = false;
        target.error = true;
        console.error('unable to retrieve Top Device');
        console.error(error.message);
      });
    },
    getTopRegion() {
      const target = _.find(this.highlights, { key: 'top_region' });
      return axios.get('/api/v1/analytics/radar/top-region').then((response) => {
        target.value_name = response.data.data.region;
        const region_users = response.data.data.users ?? 0;
        target.value = `${region_users}`;
        target.loading = false;
      }).catch((error) => {
        target.loading = false;
        target.error = true;
        console.error('unable to retrieve Top Region');
        console.error(error.message);
      });
    },
    getTotalListeningHours() {
      const target = _.find(this.highlights, { key: 'total_listening_hours' });
      return axios.get('/api/v1/analytics/radar/total-listening-hours').then((response) => {
        const total_listening_hours = response.data.data.total_listening_hours ?? 0;
        target.value = this.hoursToHumanTime(total_listening_hours);
        target.loading = false;
      }).catch((error) => {
        target.loading = false;
        target.error = true;
        console.error('unable to retrieve Top Region');
        console.error(error.message);
      });
    },
    getTopChannel() {
      return axios.get('/api/v1/analytics/radar/top-channel').then((response) => {
        if (!response.data.data.feed || _.isEmpty(response.data.data.feed)) {
          this.top_feed.error = 'No Analytics Yet.';
          this.top_feed.loading = false;
          return;
        }
        this.top_feed.name = response.data.data.feed.name;
        this.top_feed.data = response.data.data.results;
        this.top_feed.img = response.data.data.feed.feed_artwork_thumbnail_url;
        this.top_feed.loading = false;
      }).catch((error) => {
        this.top_feed.error = true;
        this.top_feed.loading = false;
        console.error(error.message);
      });
    },
    getTopEpisode() {
      return axios.get('/api/v1/analytics/radar/top-episode').then((response) => {
        if (!response.data.data.item || _.isEmpty(response.data.data.item)) {
          this.top_item.error = 'No Analytics Yet.';
          this.top_item.loading = false;
          return;
        }

        this.top_item.name = response.data.data.item.name;
        this.top_item.data = response.data.data.results;
        this.top_item.img = response.data.data.item?.artwork?.thumbnail_path;
        this.top_item.loading = false;
      }).catch((error) => {
        this.top_item.error = true;
        this.top_item.loading = false;
        console.error(error.message);
      });
    },
    hoursToHumanTime(hours) {
      if (!hours) {
        return 0;
      }
      const days = Math.floor(hours / 24);
      const remainingHours = hours % 24;
      const hoursInteger = Math.floor(remainingHours);
      const minutes = Math.floor(60 * (remainingHours - hoursInteger));
      const seconds = Math.floor(60 * (minutes - Math.floor(minutes)));

      const formattedTime = [];

      if (days > 0) {
        formattedTime.push(`${days}d`);
      }

      if (hoursInteger > 0) {
        formattedTime.push(`${hoursInteger}h`);
      }

      if (minutes > 0) {
        formattedTime.push(`${minutes}m`);
      }

      if (seconds > 0) {
        formattedTime.push(`${seconds}s`);
      }

      return formattedTime.join(' ');
    },
    setLoading(value = false) {
      // set loading to false on everything.
      _.forEach(this.highlights, (highlight) => {
        highlight.loading = value;
      });
      this.top_feed.loading = value;
      this.top_feed.error = this.customer_too_new ? null : 'No Analytics Yet';
      this.top_item.loading = value;
      this.top_item.error = this.customer_too_new ? null : 'No Analytics Yet';
    },
  },
};
</script>

<style lang="scss" scoped>
.card-stats .card-body {
  padding: 1rem 1.5rem;
  .circle-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px; /* Set your desired width and height for the circle */
    height: 50px;
    border-radius: 50%;
    font-size: 1.25rem;
  }
}

.mask {
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6); /* Adjust the alpha value for transparency */
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
